<!--
 * @version: V1.0.0
 * @Date: 2023-06-14 13:49:29
 * @LastEditors: lzq
 * @LastEditTime: 2023-08-15 09:23:44
 * @company: 睿展数据
 * @FilePath: \udi-web\src\pages\system\operate\index.vue
 * @Descripttion:
-->
<template>
  <div class="list">
    <el-card>
      <el-form inline :model="queryParams" ref="queryForm">
        <el-form-item label="操作时间" prop="dateTime">
          <el-date-picker
            v-model="queryParams.dateTime"
            size="small"
            style="width: 240px"
            value-format="yyyy-MM-dd HH:ss:mm"
            :default-time="['00:00:00', '23:59:59']"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="操作人" prop="createBy">
          <el-input
            v-model="queryParams.createBy"
            placeholder="请输入操作人"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="操作类型" prop="operateTypeName">
          <el-input
            v-model="queryParams.operateTypeName"
            placeholder="请输入操作类型"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="操作内容" prop="operateContent">
          <el-input
            v-model="queryParams.operateContent"
            placeholder="单据编号/物料名称/物料规格型号/物料编码"
            clearable
            size="small"
            style="width: 300px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="gray-card">
      <el-table v-loading="loading" :data="operateList" border stripe>
        <el-table-column width="180" label="操作时间">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="操作人" prop="createBy" :show-overflow-tooltip="true" />
<!--        <el-table-column width="200" label="操作模块" prop="operateModule" />-->
        <el-table-column
          width="200"
          label="操作类型"
          prop="operateTypeName"
          :show-overflow-tooltip="true"
        />
        <el-table-column width="160" label="单据编号" prop="busiCode" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).busiCode }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="物料名称" prop="materialName" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).materialName }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="物料编码" prop="materialCode" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).materialCode }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="批号" prop="batchNo" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).batchNo }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="仓库" prop="warehouseName" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).warehouseName }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="操作数量" prop="number" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).number }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="库存初始数量" prop="beginNum" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).beginNum }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="库存结果数量" prop="endNum" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).endNum }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="冻结初始数量" prop="freezeBeginNum" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).freezeBeginNum }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="冻结结果数量" prop="freezeEndNum" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <span v-if="isJsonString(scope.row.operateContent)">{{ JSON.parse(scope.row.operateContent).freezeEndNum }}</span>
            <span v-else></span>
          </template>
        </el-table-column>

        <el-table-column width="160" label="IP地址" prop="ipAddr" :show-overflow-tooltip="true" />
      </el-table>
    </el-card>
    <el-dialog
      title="操作详情"
      :visible="dialogVisible"
      width="60%"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
    >
      <div style="max-height: 500px; overflow-y: scroll">
        <div v-for="(item, index) in operateContent" :key="index">{{ item }}</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <pagination
      v-show="total > 0"
      :total="total"
      :page-sizes="[10, 20, 50, 100]"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { getOperateList } from '@/api/system/operate'

export default {
  name: 'Operate',
  data() {
    return {
      total: 0,
      // 日期范围
      dateRange: [],
      operateList: [],
      operateContent: null,
      dialogVisible: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        operateTypeName: undefined,
        operateModule: undefined,
        createBy: undefined,
        status: undefined
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    isJsonString(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    handlePreview(operateContent) {
      this.dialogVisible = true
      this.operateContent = operateContent.split('\n')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.$refs.queryForm.resetFields()
      this.handleQuery()
    },
    /** 查询字典类型列表 */
    getList() {
      this.loading = true
      const queryParams = JSON.parse(JSON.stringify(this.queryParams))
      if (queryParams.dateTime) {
        const [startTimeStr, endTimeStr] = queryParams.dateTime
        queryParams.startTimeStr = startTimeStr
        queryParams.endTimeStr = endTimeStr
        delete queryParams.dateTime
      }
      getOperateList(queryParams).then((response) => {
        this.operateList = response.rows
        this.total = response.total
        this.loading = false
      })
    }
  }
}
</script>
